import { auth, db } from "../firebase/config";
import { useEffect, useState } from "react";

import useTickets from "./useTickets";

const useCurrentUser = () => {
  const [currentUser, setCurrentUser] = useState<any>(null);
  const tickets = useTickets();

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        const { email, uid } = user;
        // Fetch info from ticket
        const ticket = tickets?.find((ticket) => ticket.email === email);
        const { firstname, lastname } = ticket || {};
        // Fetch profile
        const profileRef = await db.collection("profiles").doc(uid).get();
        const profileData = profileRef.data();
        setCurrentUser({
          email,
          ID: uid,
          firstname,
          lastname,
          ticket,
          ...profileData,
        });
      } else {
        setCurrentUser(null);
      }
    });
  }, [tickets]);

  return currentUser;
};

export default useCurrentUser;
